import { useMemo } from "react";
import { Outlet, useMatch } from "react-router-dom";
import { AdminLayout } from "@/components/layout/AdminLayout";

export default function AdminPage() {
  const matchDashboards = useMatch("/admin/dashboards");

  const pageTitle = useMemo(() => {
    if (matchDashboards) return "Dashboards";
    return "Management";
  }, [matchDashboards]);

  return (
    <AdminLayout pageTitle={pageTitle} breadcrumbs={[{ title: "Management", href: "/admin" }]}>
      <Outlet />
    </AdminLayout>
  );
}
